import BaseApi from '@/api/BaseApi'

export default class BrandApi extends BaseApi {
    async getBrandById (organizationId) {
        return this.get(`/api/v1.0/brands/${organizationId}`)
    }
    async createBrand (params = {
        organizationId: null,
        url: null,
        primaryColor: null,
        secondaryColor: null,
        showPoweredBy: null
    }) {
        return this.post(`/api/v1.0/brands`, params)
    }
    async addImage (image) {
        return this.post(`/api/v1.0/brands/image`, image)
    }
    async updateBrand (params = {
        organizationId: null,
        url: null,
        primaryColor: null,
        secondaryColor: null,
        showPoweredBy: null
    }) {
        return this.put(`/api/v1.0/brands`, params)
    }
    async deleteImage (imageId) {
        return this.delete(`/api/v1.0/brands/image/${imageId}`)
    }
}
